$(window).on('load', function () {

	// initialization of HSMegaMenu component
	$('.js-mega-menu').HSMegaMenu({
	  event: 'hover',
	  pageContainer: $('.container'),
	  breakpoint: 767.98,
	  hideTimeOut: 0
	});

	// initialization of HSMegaMenu component
	$('.js-breadcrumb-menu').HSMegaMenu({
	  event: 'hover',
	  pageContainer: $('.container'),
	  breakpoint: 991.98,
	  hideTimeOut: 0
	});

	// initialization of svg injector module
	$.HSCore.components.HSSVGIngector.init('.js-svg-injector');

 });

$(document).on('ready', function () {

	// initialization of header
	$.HSCore.components.HSHeader.init($('#header'));

	// initialization of unfold component
	$.HSCore.components.HSUnfold.init($('[data-unfold-target]:not(#filter3DropdownInvoker)'));

	$.HSCore.components.HSUnfold.init($('#filter3DropdownInvoker'));

	// initialization of range datepicker
	$.HSCore.components.HSRangeDatepicker.init('.js-range-datepicker');

	// initialization of malihu scrollbar
	$.HSCore.components.HSMalihuScrollBar.init($('.js-scrollbar'));

	// initialization of forms
	$.HSCore.components.HSFocusState.init();

	// initialization of form validation
	$.HSCore.components.HSValidation.init('.js-validate');


	// initialization of form validation
	$.HSCore.components.HSValidation.init('.js-validate-signup', {
	  rules: {
		 password_again: {
			equalTo: '#signupSrPassword'
		 }
	  }
	});




	// initialization of form validation
// 	$.HSCore.components.HSValidation.init('.js-validate-signup', {
// 	  rules: {
// 		 password_again: {
// 			equalTo: '#signupSrPassword'
// 		 },
// 		 g-recaptcha-response: "required"
// // 		 "hiddenRecaptcha": {
// // 			  required: function() {
// // 					if(g-recaptcha-response() == '') {
// // 						 return true;
// // 					} else {
// // 						 return false;
// // 					}
// // 			  }
// // 		 }
// 	  }
// 	});

	// initialization of form validation
// 	$.HSCore.components.HSValidation.init('.js-validate-signup', {
// 	  rules: {
// 		 password_again: {
// 			equalTo: '#resetSrPassword'
// 		 }
// 	  }
// 	});

	// initialization of password strength module
	$.HSCore.components.HSPasswordStrength.init('#signupSrPassword');

	// initialization of cubeportfolio
	$.HSCore.components.HSCubeportfolio.init('.cbp');

	// initialization of sticky blocks
	$.HSCore.components.HSStickyBlock.init('.js-sticky-block');

	// initialization of show animations
	$.HSCore.components.HSShowAnimation.init('.js-animation-link');

	// initialization of slick carousel
	$.HSCore.components.HSSlickCarousel.init('.js-slick-carousel');

	// initialization of show animations
	$.HSCore.components.HSShowAnimation.init('.js-animation-link');

	// initialization of select picker
	$.HSCore.components.HSSelectPicker.init('.js-select');

	// initialization of fancybox
	$.HSCore.components.HSFancyBox.init('.js-fancybox');

	// initialization of go to
	$.HSCore.components.HSGoTo.init('.js-go-to');

	// initialization of step form
	$.HSCore.components.HSStepForm.init('.js-step-form');

	// initialization of datatables
	$.HSCore.components.HSDatatables.init('.js-datatable');

	// initialization of file attach module
	$.HSCore.components.HSFileAttach.init('.js-custom-file-attach');

	// initialization of autonomous popups
	$.HSCore.components.HSModalWindow.init('[data-modal-target]', '.js-modal-window', {
		autonomous: true
	});

	$.HSCore.components.HSToggleState.init('.js-toggle-state');
	
   var items = $.HSCore.components.HSChartPie.init('.js-pie');

 });

		

// My scripts

$(function() {
    'use strict';

	$("a#main-enquire-button").click(function (event) {
		if ($(this).hasClass("disabled")) {
			event.preventDefault();
		}
		$(this).addClass("disabled");
	});

	$('.chosen-select').chosen();
	
    $('.btn-save').click(function(e) {
			var ctl	= $(this).attr('data-action');
			var property_id	= parseInt($(this).attr('data-id'));
			var url = $(this).attr('data-url');
			var reference = this; 
			var pub = $(this).attr('data-name') ;
			$.ajax({
				url: url,
				type: 'GET',
				success: function (result){
				if (ctl === 'save') {
					var message = pub + ' saved to favourites';
						$(reference).attr('href', '/user/saved-properties/remove/?submit=remove&id=' +property_id);
						$(reference).attr('data-url', '/user/saved-properties/remove/?submit=remove&id=' +property_id);
						$(reference).attr('data-action', 'remove');
						$(reference).find(".action-container").html('<span class="fas fa-bookmark mr-2"></span>Unsave');
						toastr.success(message, {
								positionClass: "toast-top-right",
								closeButton: true,
								progressBar: true,
								newestOnTop: true,
								showDuration: 50000,
								timeOut: 50000
						});
				} else {
					var message = pub + ' removed from favourites';
						$(reference).attr('href', '/user/saved-properties/add/?submit=add&id=' +property_id);
						$(reference).attr('data-url', '/user/saved-properties/add/?submit=add&id=' +property_id);
						$(reference).attr('data-action', 'save');
						$(reference).find(".action-container").html('<span class="far fa-bookmark mr-2"></span>Save for later');
						toastr.success(message, {
								positionClass: "toast-top-right",
								closeButton: true,
								progressBar: true,
								newestOnTop: true,
								showDuration: 50000,
								timeOut: 50000
						});
				}
			}
			});
		e.preventDefault();
   });

    $('.btn-bookmark').click(function(e) {
			var ctl	= $(this).attr('data-action');
			var property_id	= parseInt($(this).attr('data-id'));
			var url = $(this).attr('data-url');
			var reference = this; 
			var pub = $(this).attr('data-name') ;
			$.ajax({
				url: url,
				type: 'GET',
				success: function (result){
				if (ctl === 'save') {
					var message = pub + ' saved to favourites';
						$(reference).attr('href', '/user/saved-properties/remove/?submit=remove&id=' +property_id);
						$(reference).attr('data-url', '/user/saved-properties/remove/?submit=remove&id=' +property_id);
						$(reference).attr('data-action', 'remove');
						$(reference).find(".action-container").html('<span class="fas fa-bookmark p-2 text-secondary"></span>');
						toastr.success(message, {
								positionClass: "toast-top-right",
								closeButton: true,
								progressBar: true,
								newestOnTop: true,
								showDuration: 50000,
								timeOut: 50000
						});
				} else {
					var message = pub + ' removed from favourites';
						$(reference).attr('href', '/user/saved-properties/add/?submit=add&id=' +property_id);
						$(reference).attr('data-url', '/user/saved-properties/add/?submit=add&id=' +property_id);
						$(reference).attr('data-action', 'save');
						$(reference).find(".action-container").html('<span class="far fa-bookmark p-2 text-secondary"></span>');
						toastr.success(message, {
								positionClass: "toast-top-right",
								closeButton: true,
								progressBar: true,
								newestOnTop: true,
								showDuration: 50000,
								timeOut: 50000
						});
				}
			}
			});
		e.preventDefault();
   });



    $('.btn-alert-save').click(function(e) {
			var ctl	= $(this).attr('data-action');
			var property_id	= parseInt($(this).attr('data-id'));
			var url = $(this).attr('data-url');
			var reference = this; 
			var search = $(this).attr('data-name') ;
			var msg = $(this).attr('data-msg') ;
			$.ajax({
				url: url,
				type: 'GET',
				success: function (result){
				if (ctl === 'create') {
					var message = msg;
						$(reference).attr('href', '#');
						$(reference).attr('data-url', '#');
						$(reference).attr('data-action', 'remove');
						$(reference).find(".action-container").html('<i class="fas fa-star fa-highlight-color-secondary"></i> Save search');
						toastr.success(message, {
								positionClass: "toast-top-right",
								closeButton: true,
								progressBar: true,
								newestOnTop: true,
								showDuration: 50000,
								timeOut: 50000
						});
				} 
			}
			});
		e.preventDefault();
   });




// Submit alerts

	$('div.frequency-edit').on( "submit", ".form-frequency", function(e) {
		$.ajax({
			type: "GET",
			url: "/user/alerts-and-searches/edit/",
			data: $(this).serialize(),
					success:function(result){
					var message = "Search frequency changed";
						toastr.success(message, {
								positionClass: "toast-top-right",
								closeButton: true,
								progressBar: true,
								newestOnTop: true,
								showDuration: 50000,
								timeOut: 50000
						});
			}
		});
		e.preventDefault();
	});

	
	$('div.frequency-edit').on( "change", ".select-frequency", function() {
		var form = $(this).closest('form');
		$(form).submit();
	});

// Enquiry form


		$('.guest-form input[name="infopack"]').on('change', function (event) {
		var infopack = $('input[name="infopack"]:checked').val();

			if(infopack === 'Post') { // hide until infopack = post
				$('div.address-details').fadeIn().css('display', 'block'); // show
				$('div.address-details input').prop('required',true);
				$('div.address-details textarea').prop('required',true);
			} else {
				$('div.address-details').fadeOut(); // hide again
				$('div.address-details input').removeAttr('required'); // remove required attribute
				$('div.address-details input').val(''); // blank values
				$('div.address-details textarea').removeAttr('required'); // remove required attribute
				$('div.address-details textarea').val(''); // blank values
			}
		}).trigger('change');

		$('.user-form input[name="infopack"],.candidate-form input[name="infopack"]').on('change', function (event) {
		var infopack = $('input[name="infopack"]:checked').val();

			if(infopack === 'Post') { // hide until infopack = post
				$('div.address-details').show(); // show
				$('div.address-details input').prop('required',true);
				$('div.address-details textarea').prop('required',true);
			} else {
				$('div.address-details').hide(); // hide again
				$('div.address-details input').removeAttr('required'); // remove required attribute
				$('div.address-details textarea').removeAttr('required'); // remove required attribute
			}
		}).trigger('change');


  $.validator.addMethod('talentpool', function (value, element, params) {
    const talentpool = $('input[name=cf_2296]:checked').val()
    const fields = [
      $('input[name=cf_2300]:checked').val(),
      $('input[name=cf_2302]:checked').val(),
      $('input[name=cf_2304]:checked').val()
    ]
    const yesFields = fields.filter(function (val) {
      return val === 'Yes'
    })

    return !(talentpool === 'Yes' && yesFields.length === 0)
  }, 'You must select an option for Talent Pool.')

  $('input[name=cf_2296], input[name=cf_2300], input[name=cf_2302], input[name=cf_2304]').on('keyup focusout', function () {
    $('input[name="cf_2296"]').valid()
  })



// 		$('.user-form-sc input[name=cf_2296]').on('change', function (event) {
// 		var talentpool = $('#cf_2296_no:checked').val();
// 
// 			if(talentpool === 'No') { // hide until talentpool = post
// 				$('#cf_2300').attr('checked', false).attr('disabled', true);
// 				$('#cf_2302').attr('checked', false).attr('disabled', true);
// 				$('#cf_2304').attr('checked', false).attr('disabled', true);
// 			} else {
// 				$('#cf_2300').attr('checked', true).attr('disabled', false);
// 				$('#cf_2302').attr('checked', true).attr('disabled', false);
// 				$('#cf_2304').attr('checked', true).attr('disabled', false);
// 			}
// 		}).trigger('change');

		$('.user-form-sc input[name=cf_2296], .candidate-form-sc input[name=cf_2296]').on('change', function (event) {
		var talentpool = $('input[name=cf_2296]:checked').val();
			if(talentpool === 'No') { // hide until talentpool = post
				$('#cf_2300').prop('checked', false).attr('disabled', true);
				$('#cf_2302').prop('checked', false).attr('disabled', true);
				$('#cf_2304').prop('checked', false).attr('disabled', true);
				$('#cf_2298').val('').prop('disabled', true).trigger("chosen:updated");
			} else {
				$('#cf_2300').prop('disabled', false);
				$('#cf_2302').prop('disabled', false);
				$('#cf_2304').prop('disabled', false);
				$('#cf_2298').prop('disabled', false).trigger("chosen:updated");
			}
		}).trigger('change');

// 		$('.user-form-sc input[name=cf_747], .candidate-form-sc input[name=cf_747]').on('change', function (event) {
// 		var has_pl = $('input[name=cf_747]:checked').val();
// 			if(has_pl === 'No') { // hide until talentpool = post
// 				$('div.pl-provider').fadeIn(); // show
// 			} else {
// 				$('div.pl-provider').hide(); // hide again
// 			}
// 		}).trigger('change');

		$('.user-form-sc select[name=cf_765], .candidate-form-sc select[name=cf_765]').on('change', function (event) {
		var type_of_pub_looking_for = $('select[name="cf_765"]').val();
			if(
			type_of_pub_looking_for.includes('Community local with food') ||
			type_of_pub_looking_for.includes('High Street With food') ||
			type_of_pub_looking_for.includes('Urban high volume food') ||
			type_of_pub_looking_for.includes('Restaurant') ||
			type_of_pub_looking_for.includes('Hotel')
			) { // hide until food is selected
				$('div.food-menu').fadeIn(); // show
				$('div.food-menu select').prop('required',true);
			} else {
				$('div.food-menu').fadeOut(); // hide again
				$('div.food-menu select').removeAttr('required'); // remove required attribute
				$('div.food-menu select').val(''); // blank values
			}
		}).trigger('change');

		$('.user-form-sc input[name=cf_1238], .candidate-form-sc input[name=cf_1238]').on('change', function (event) {
		var catering = $('input[name=cf_1238]:checked').val();
			if(catering === '1') { // ksjdafgkhagfgjkhkfgdh
				$('div.catering-info').fadeIn(); // show
			} else {
				$('div.catering-info').hide(); // hide again
				$('div.catering-info input').val('0'); // blank values
			}
		}).trigger('change');


//     $('#element').on('click', function () {
//         $.fn.custombox( this );
//         return false;
//     });

      // initialization of autonomous popups
    $('.btn-basket').click(function(e) {
			var ctl	= $(this).attr('data-action');
			var url = $(this).attr('data-url');
			var reference = this; 
// 			var search = $(this).attr('data-name') ;
// 			var msg = $(this).attr('data-msg') ;
			$.ajax({
				url: url,
				type: 'GET',
				success: function (result){
				var modal = new Custombox.modal({
				  content: {
					 effect: 'fadein',
					 target: '#basketModal'
				  }
				});
				if (ctl === 'basket') {
					modal.open();
				} 
			}
			});
		e.preventDefault();
   });

	$('a.track,input.track').each(function() {
		$(this).on('click', function(event) {
			ga('send', 'event', $(this).data("category"), $(this).data("action"), $(this).data("label"), $(this).data("value"));
		});
	});


	$(".reset").click(function() {
		$(this).closest('#filter-search').find("input[type=checkbox]").prop('checked', false);
	//    $(this).closest('#filter-search').find("input[type=checxbox], textarea").val("");
		$(':input','#filter-search')
		  .not(':button, :submit, :reset, :hidden')
		  .val('')
		  .prop('checked', false)
		  .prop('selected', false);
	});
	
	$.validator.addMethod('financial', function(value, element, params) {
		 var planned_investment = parseInt($('input[name="cf_625"]').val()),
			  instant_cash_savings = parseInt($('input[name="cf_741"]').val()),
			  bank_loan = parseInt($('input[name="cf_628"]').val()),
			  credit_card = parseInt($('input[name="cf_631"]').val()),
			  loan_against_equity = parseInt($('input[name="cf_630"]').val()),
			  borrowed_from_family_friends = parseInt($('input[name="cf_742"]').val()),
			  sale_of_property = parseInt($('input[name="cf_629"]').val()),
			  fund_source = parseInt(instant_cash_savings) + parseInt(bank_loan) + parseInt(credit_card) + parseInt(loan_against_equity) + parseInt(borrowed_from_family_friends) + parseInt(sale_of_property);
// 		 console.log('planned_investment = ' + planned_investment);
// 		 console.log('fund_source = ' + fund_source);
// 		 console.log('result = ' + planned_investment !== fund_source);
		 return planned_investment === fund_source;
	}, "You must state the breakdown of how your total planned investment will be funded by using the fields below. Your source of funds must equal your total planned investment.");


		$('input[name="cf_741"], input[name="cf_628"], input[name="cf_631"], input[name="cf_630"], input[name="cf_742"], input[name="cf_629"]').on('keyup focusout', function() {
			 $('input[name="cf_625"]').valid();
		});



		$('.user-form-sc select[name=cf_737], .candidate-form-sc select[name=cf_737]').on('change', function (event) {
		var previous_experience = $('select[name="cf_737"] option:selected').val();
			if(previous_experience === 'None' || previous_experience === '1 year' || previous_experience === '2 years') { // hide until talentpool = post
					$('select[name="cf_2408"]').attr('required', 'required');
					$('select[name="cf_2410"]').attr('required', 'required');
					$('div.previous-experience').fadeIn('slow'); // show
// 				$('#cf_2300').prop('checked', false).attr('disabled', true);
// 				$('#cf_2302').prop('checked', false).attr('disabled', true);
// 				$('#cf_2304').prop('checked', false).attr('disabled', true);
// 				$('#cf_2298').val('').prop('disabled', true).trigger("chosen:updated");
			} else {
					$('select[name="cf_2408"]').removeAttr('required');
					$('select[name="cf_2408"]').val('');
					$('select[name="cf_2410"]').removeAttr('required');
					$('select[name="cf_2410"]').val('');
					$('div.previous-experience').hide(); // hide again
// 				$('#cf_2300').prop('disabled', false);
// 				$('#cf_2302').prop('disabled', false);
// 				$('#cf_2304').prop('disabled', false);
// 				$('#cf_2298').prop('disabled', false).trigger("chosen:updated");
			}
		}).trigger('change');




});

   
//   $(window).on('load', function () {
//     // initialization of svg injector module
// 	$.HSCore.components.HSModalWindow.init('.pbm-modal-window', {
// 		autonomous: true
// 	});
//   });

